import { UrlApi } from "../../../../../../services/apirest";

// El backend responde 500 si falla el INSERT; se lanza error para que el
// llamador pueda cortar el guardado.
const postJson = async (ruta, payload) => {
  const res = await fetch(UrlApi + ruta, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error(`Error HTTP ${res.status} en ${ruta}`);
  }
  return res.json();
};

// Devuelve { insertId }.
export const crearPedido = (payload) => postJson("/envasado_pedidos", payload);

export const crearRenglonPedido = (payload) =>
  postJson("/envasado_pedidos_renglon", payload);

export const getPedidosPendientesDireccion = async (idDireccion) => {
  const response = await fetch(UrlApi + "/envasado_pedidos/xdir/" + idDireccion);
  return response.json();
};
